import * as React from "react"
import { connect } from "react-redux"

import { Dropdown, Menu, Label, Button, Divider } from "semantic-ui-react"

import { withRouter } from "react-router-dom"
import icon from "../../../core/assets/icon.png"

import { isNotEmptyObject, languageOptions } from "../../../utils"
import ButtonLink from "../buttons/com_button-link"
import { onChangeLang, changeSelectedSupplier } from "../../../core/actions"

import { Roles } from "../../../utils"
import {
  getActiveLang,
  getUserRole,
  getUserManagedSupplierList,
  getUserSelectedSupplier,
  getTranslationsByScope,
  DropitState,
} from "../../../core/reducers"
import { ISupplierInfo, permanentFormIds } from "../../../models"
import { getConfiguration } from "../../../config"
import { getActions } from "../../product-form/_actions"
import { LocalStorageColumnsKeys } from "../../../utils/local-storage-keys"
import { getPca } from "../../../authProvider"
import { useIsAuthenticated, useMsal } from "@azure/msal-react"
import { EndSessionRequest } from "@azure/msal-browser"
import { Multilang } from "../../../models/product/multilang-string"

const Header = (props: any) => {
  const {
    productLabels = [],
    changeLang,
    activeLang,
    managedSupplierList,
    selectedSupplier,
    translations,
    closeFormId,
  } = props

  const { instance } = useMsal()

  const onChangeSelectedSupplier = (e: object, { value }: any) => {
    if (
      !props.selectedSupplier.supplierName ||
      value.supplierName !== props.selectedSupplier.supplierName
    ) {
      Object.keys(LocalStorageColumnsKeys).map((o) =>
        localStorage.removeItem(LocalStorageColumnsKeys[o])
      )
      props.changeSelectedSupplier(value)
    }
  }

  const permanentLinks = [
    {
      label: translations.homeLabel,
      to: "/",
    },
    {
      label: translations.addProductLabel,
      to: "/product_form/newProduct",
    },
    {
      label: translations.yourProductsLabel,
      to: "/product_list",
    },
  ]

  const formLinks = Object.keys(productLabels)
    .filter(
      (formId: any) =>
        ![permanentFormIds.NEW_PRODUCT, permanentFormIds.MULTI_MODIF].includes(
          formId
        )
    )
    .map((formId: any) => ({
      label:
        translations.modifyProductLabel +
        " " +
        (isNotEmptyObject(productLabels[formId])
          ? Multilang.String.GetValue(
              productLabels[formId],
              activeLang,
              true
            ) || ""
          : translations.invalidProduct),
      to: `/product_form/${formId}`,
      formId,
    }))

  // const logoutRequest : EndSessionRequest = {}
  const disconnect = () => {
    // localStorage.clear()
    // const authProvider = getAuthProvider()
    // authProvider.getAuthorityInstance()
    // const t = authProvider.getAllAccounts()
    // console.log('t :>> ', t);
    // authProvider.getU
    instance.logoutRedirect({
      account: instance.getActiveAccount(),
    })
    //   const c = getConfiguration()

    // const myMsal = new msal.UserAgentApplication(c.B2C_CONFIGURATION);

    // myMsal.logout();
  }

  const options = managedSupplierList.map((r: any) => ({
    text: r.supplierName,
    value: r,
    key: r.supplierName,
  }))

  return (
    <Menu pointing={true} secondary={true}>
      <Menu.Item fitted={true} style={{ padding: 2 }}>
        <img src={icon} alt="Logo Drop'It" />
      </Menu.Item>

      <div className={"header-permanent-links"}>
        {permanentLinks.map(({ label, ...other }, index) => (
          <ButtonLink {...other} key={index} oneLine={true}>
            {label}
          </ButtonLink>
        ))}
      </div>
      <Divider vertical />
      <div className={"header-form-links"}>
        {formLinks.map(({ label, ...other }, index) => (
          <ButtonLink
            {...other}
            key={index}
            onClose={closeFormId}
            oneLine={true}
          >
            {label}
          </ButtonLink>
        ))}
      </div>

      <Menu.Menu position="right">
        {props.role === Roles.MARKET_LEADER ? (
          <Menu.Item className="marketLeaderMenuItem marketLeaderLeftItem">
            <Label className="marketLeaderLabel">Fournisseur :</Label>
          </Menu.Item>
        ) : (
          ""
        )}
        {props.role === Roles.MARKET_LEADER ? (
          <Menu.Item className="marketLeaderMenuItem marketLeaderRightItem">
            <Dropdown
              className="marketLeaderDropdown"
              onChange={onChangeSelectedSupplier}
              options={options}
              value={selectedSupplier}
              search
            />
          </Menu.Item>
        ) : (
          ""
        )}
        <Menu.Item>
          <Dropdown
            onChange={changeLang}
            options={languageOptions}
            value={activeLang}
          />
        </Menu.Item>

        <Menu.Item onClick={disconnect}>
          {translations.disconnectLabel}
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  )
}

const mapStateToProps = (state: DropitState, props: any) => {
  const productLabels = Object.keys(state.productForm.dataByFormId).reduce(
    (accumulator, formId) => {
      accumulator[formId] =
        state.productForm.dataByFormId[formId].product?.label || []
      return accumulator
    },
    {}
  )

  return {
    productLabels,
    lang: state.lang,
    activeLang: getActiveLang(state),
    role: getUserRole(state),
    managedSupplierList: getUserManagedSupplierList(state),
    selectedSupplier: getUserSelectedSupplier(state),
    translations: getTranslationsByScope(state, "header"),
  }
}

const mapDispatchToProps = (dispatch: any) => {
  const productFormActions = getActions(dispatch)
  return {
    changeLang: (e: any, payload: any) => dispatch(onChangeLang(e, payload)),
    changeSelectedSupplier: (value: ISupplierInfo) =>
      dispatch(changeSelectedSupplier(value)),
    closeFormId: productFormActions._closeFormId,
  }
}

export default withRouter<any & any>(
  connect(mapStateToProps, mapDispatchToProps)(Header)
)
